import { render } from "./llmDialogic.vue?vue&type=template&id=65872406&scoped=true"
import script from "./llmDialogic.vue?vue&type=script&lang=js"
export * from "./llmDialogic.vue?vue&type=script&lang=js"

import "./llmDialogic.vue?vue&type=style&index=0&id=65872406&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65872406"]])

export default __exports__